import React from 'react';
import styled from 'styled-components';
import { FormSection } from 'redux-form';

import { FlexRow } from 'components/Shared/Scaffolding';
import { Input } from 'components/Shared/Forms';
import { SCAFFOLDING } from 'theme';

const StyledFormSection = styled(FormSection)`
    > * + * {
        margin-top: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    }
`;

const InfoWindowContainer = ({ defaultValues }) => (
    <StyledFormSection name="container">
        <FlexRow>
            <Input name="maxWidth" label="Max Width" type="int" unitAfter="px" width="50%" min={0} optional />
            <Input name="maxHeight" label="Max Height" type="int" unitAfter="px" width="50%" min={0} optional />
        </FlexRow>
        <FlexRow>
            <Input
                name="top"
                label="Top Marker Offset"
                type="int"
                unitAfter="px"
                width="50%"
                placeholder={defaultValues.top}
            />
            <Input
                name="left"
                label="Left Marker Offset"
                type="int"
                unitAfter="px"
                width="50%"
                placeholder={defaultValues.left}
            />
        </FlexRow>
        <FlexRow>
            <Input
                name="padding"
                label="Padding"
                type="int"
                unitAfter="px"
                width="50%"
                min={0}
                placeholder={defaultValues.padding}
            />
            <Input
                name="borderRadius"
                label="Corner Radius"
                type="int"
                unitAfter="px"
                width="50%"
                min={0}
                placeholder={defaultValues.borderRadius}
            />
        </FlexRow>
    </StyledFormSection>
);

export default InfoWindowContainer;
